import React from 'react';

class Privacy extends React.Component {
  render() {
      document.body.classList.remove('inner-page');
  	return (
        <section className="p-0">
            <div className="">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <br/><br/>
                            <div className="text-left">
                                <h2>Privacy Policy Summary</h2>
                                <p>Your data is private and is only used for the purpose of providing the features and services that are used by our apps. We don't sell your data to anyone.</p>
                                
                                <p>We’ve designed the Calist app to respect your privacy and secure your data. Our app is supported by our user’s memberships - we don’t believe in selling your data, showing you ads/special offers, or annoying you with tricks or pop-ups.</p>
                                
                                <p>Our full legal privacy policy can be found <a href="/privacy-full">here</a>, but to help cut through the legal jargon we’ve written a high level summary below of how our apps work, what data they collect, and what we use it for. If you have any concerns about any of this then please get in touch with us at support@calist.co - we’re happy to answer any questions.</p>
                                <ul style={{paddingLeft: 30, listStyle: 'disc'}}>
                                    <li>
                                        <p>The app uses our membership service, which is a way to allow you to log in securely and allow the apps access to your preferences, content and memberships across muliple devices. There are currently one way to login with Apple. Sign in with Apple allows you to choose to hide your email address, by generating a random anonymous email that looks like xxxxxxxxx@privaterelay.appleid.com. This data is encrypted in transit and at rest, and your password is hashed using Scrypt - an industry standard method for securing passwords.</p>
                                    </li>
                                    <li>
                                        <p>When the Calist app is first opened you are asked for permission to access your calendar and contacts. Calist app will then sync with your iOS calendar locally - we never transmit or store your events, contacts and calendar data.</p>

                                    </li>
                                </ul>
                                <h3>Analytics and crash reporting</h3>
                                <p>In order to support, maintain and improve our apps we use Google Analytics, Firebase Analytics, Firebase Performance Monitoring, and Fabric (all Google services). We send anonymised tracking events to these services to help us understand general trends in usage and performance of various features in the apps. We don’t send anything personally identifiable - none of your Calist app data is transmitted.</p>
                                <p>Here are some of the kinds of questions that these tools help us answer:</p>
                                <ul style={{paddingLeft: 30, listStyle: 'circle'}}>
                                    <li><p>Are new users discovering how to create an event? (or do we need to improve how we explain this in onboarding?)</p></li>
                                    <li><p>How often do users start creating an event in Calist and then cancel? (Is there something that people find confusing? How can we make this clearer?)</p></li>
                                    <li><p>How long does syncing calendar data in Calist take? Has this improved with the latest update?</p></li>
                                    <li>
                                        <p>We also use Crashlytics (another Google service) for tracking crashes and app stability. This lets us see anonymised data about the number and type of errors so we can fix them - e.g. if the app is using too much memory on older devices, or if there’s a bug that only shows up on the new version of iOS.
                                        </p>
                                    </li>
                                </ul>

                                <p><a href="/privacy-full">See full privacy policy</a></p>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
  	);
  }
}


export default Privacy;


// WEBPACK FOOTER //
// ./src/pages/privacy.js